module.exports = __webpack_public_path__ + "img/lt.4396ec74.svg";